import type { Filter, SourceFilter } from '@/types';

type ReturnType = Record<string, Record<string, Array<string | undefined>>>;

const getFilterValue = (filter: Filter): string => {
  if ('people_id' in filter && typeof filter.people_id === 'string') {
    return filter.people_id;
  }
  if ('id' in filter && typeof filter.id === 'string') {
    return filter.id;
  }
  if ('key' in filter && typeof filter.key === 'string') {
    return filter.key;
  }
  return '';
};

export const normalizeFilters = (filters: SourceFilter): ReturnType => {
  const normalized: ReturnType = {};

  for (const source in filters) {
    normalized[source] = {};
    for (const filterName in filters[source]) {
      normalized[source][filterName] =
        filters[source][filterName].map(getFilterValue);
    }
  }

  return normalized;
};
